module.exports = __webpack_public_path__ + "static/media/chemistry.42fe7ca7.jpg";